var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "timeline",
    width: 17.578,
    height: 20,
    viewBox: "0 0 17.578 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#495057}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    d: "M394.516 46.82a1.758 1.758 0 1 1-2.344-1.65v-3.731a1.747 1.747 0 0 1 0-3.3v-3.731a1.758 1.758 0 1 1 1.172 0v3.731a1.747 1.747 0 0 1 0 3.3v3.731a1.755 1.755 0 0 1 1.172 1.65z",
    className: "cls-1",
    transform: "translate(-391 -29.789)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    d: "M91.586 361h9.375a.586.586 0 0 1 .586.586v4.727a.586.586 0 0 1-.586.586h-9.375a.586.586 0 0 1-.586-.586v-4.727a.586.586 0 0 1 .586-.586zm7.031 3.516a.586.586 0 1 0-.586-.586.586.586 0 0 0 .586.586zm-4.687 0h2.344a.586.586 0 0 0 0-1.172H93.93a.586.586 0 0 0 0 1.172z",
    className: "cls-1",
    transform: "translate(-86.313 -346.898)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    d: "M43.891 181.586v4.688a.586.586 0 0 1-.586.586H31.586a.586.586 0 0 1-.586-.586v-4.687a.586.586 0 0 1 .586-.586H43.3a.586.586 0 0 1 .591.585zm-5.273 1.758H33.93a.586.586 0 0 0 0 1.172h4.688a.586.586 0 0 0 0-1.172zm2.344 0a.586.586 0 1 0 .586.586.586.586 0 0 0-.587-.586z",
    className: "cls-1",
    transform: "translate(-26.313 -173.93)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    d: "M91.586 5.9A.586.586 0 0 1 91 5.313V.586A.586.586 0 0 1 91.586 0h9.375a.586.586 0 0 1 .586.586v4.727a.586.586 0 0 1-.586.586zm4.688-3.516H93.93a.586.586 0 0 0 0 1.172h2.344a.586.586 0 0 0 0-1.172zm2.344 0a.586.586 0 1 0 .586.586.586.586 0 0 0-.587-.587z",
    className: "cls-1",
    transform: "translate(-86.313)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeline);
export default __webpack_public_path__ + "static/media/icon-timeline.2b496807e16578090ddca17f06af1d3e.svg";
export { ForwardRef as ReactComponent };